import React from 'react';
import Icon, { IconProps } from './index';
import { WithConfirmation } from '../ConfirmationDialog/WithConfirmation';

type ConfirmationIconProps = IconProps & {
  confirmText: string;
  onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onCancel?: () => void;
};

//Same as Icon but with ConfirmationDialog
const ConfirmationIcon = (props: ConfirmationIconProps) => {
  return (
    <WithConfirmation
      onConfirm={props.onClick}
      onCancel={props.onCancel}
      message={props.confirmText}
    >
      {(onOpen: () => void) => <Icon {...props} onClick={onOpen} />}
    </WithConfirmation>
  );
};

export default ConfirmationIcon;
